/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './alarm-rules.scss';

/* eslint-disable import/no-unresolved, import/default */

import alarmRulesTemplate from './alarm-rules.tpl.html';
import alarmRuleDialogTemplate from './alarm-rule.dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.alarmRules', [])
    .directive('tkAlarmRules', AlarmRules)
    .name;

/*@ngInject*/
export function AlarmRules() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            rulesScope: '=',
            entityId: '=',
            allAlarmRules: '=alarmRules',
            isReadOnly: '='
        },
        controller: AlarmRulesController,
        controllerAs: 'vm',
        templateUrl: alarmRulesTemplate
    };
}

/*@ngInject*/
function AlarmRulesController($rootScope, $scope, $mdDialog, $document, gatewayGroupService, $filter, $translate, $mdMedia, types, tkDialogs) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;

        vm.alarmRules = [];
        vm.rowsCount = 0;
        vm.selectedAlarmRules = [];

        vm.query = {
            order: 'name',
            limit: 15,
            page: 1,
            search: null
        };

        vm.limitOptions =
            [15, 30, 45];

        vm.enterFilterMode = enterFilterMode;
        vm.exitFilterMode = exitFilterMode;

        vm.onReorder = function () {
            updateAlarmRules();
        };

        vm.onPaginate = function () {
            updateAlarmRules();
        };

        vm.openAlarmRule = openAlarmRule;
        vm.addAlarmRule = addAlarmRule;
        vm.deleteAlarmRule = deleteAlarmRule;
        vm.deleteAlarmRules = deleteAlarmRules;

        vm.loading = function () {
            return $rootScope.loading;
        };
    };

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.entityId', (newVal) => {
        if (newVal) {
            reload();
        }
    });

    $scope.$watch("vm.query.search", function (newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateAlarmRules();
        }
    });

    function enterFilterMode () {
        vm.query.search = '';
    }

    function exitFilterMode () {
        vm.query.search = null;
        updateAlarmRules();
    }

    function reload() {
        vm.alarmRules.length = 0;
        vm.rowsCount = 0;
        if (!vm.allAlarmRules) {
            vm.allAlarmRules = [];
        }
        vm.selectedAlarmRules = [];
        updateAlarmRules();
    }

    function updateAlarmRules() {
        vm.selectedAlarmRules = [];
        var result = $filter('orderBy')(vm.allAlarmRules, vm.query.order);
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.rowsCount = result.length;
        var startIndex = vm.query.limit * (vm.query.page - 1);
        vm.alarmRules = result.slice(startIndex, startIndex + vm.query.limit);
    }

    function openAlarmRule($event, alarmRule) {
        openAlarmRuleDialog($event, alarmRule);
    }

    function addAlarmRule($event) {
        openAlarmRuleDialog($event);
    }

    function openAlarmRuleDialog($event, alarmRule) {
        if ($event) {
            $event.stopPropagation();
        }
        var isAdd;
        var alarmRuleIndex = -1;
        if (alarmRule) {
            isAdd = false;
            alarmRuleIndex = vm.allAlarmRules.indexOf(alarmRule);
            if (!vm.isReadOnly) {
                alarmRule = angular.copy(alarmRule);
            }
        } else {
            isAdd = true;
            alarmRule = {
                alarmTriggers: [],
                notifications: []
            };
        }
        $mdDialog.show({
            controller: 'AlarmRuleController',
            controllerAs: 'vm',
            templateUrl: alarmRuleDialogTemplate,
            parent: angular.element($document[0].body),
            locals: {
                rulesScope: vm.rulesScope,
                isReadOnly: vm.isReadOnly,
                isAdd: isAdd,
                alarmRule: alarmRule
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then(function (alarmRule) {
            if (isAdd) {
                vm.allAlarmRules.push(alarmRule);
                saveAlarmRules();
            } else if (!vm.isReadOnly && alarmRuleIndex > -1) {
                vm.allAlarmRules[alarmRuleIndex] = alarmRule;
                saveAlarmRules();
            }
        }, function () {
        });
    }

    function deleteAlarmRule($event, alarmRule) {
        var title = $translate.instant('alarm-rule.delete-alarm-rule-title', {alarmRuleName: alarmRule.name});
        var content = $translate.instant('alarm-rule.delete-alarm-rule-text');
        var label = $translate.instant('alarm-rule.delete-alarm-rule');
        tkDialogs.confirm($event, title, content, label).then(
            () => {
                var index = vm.allAlarmRules.indexOf(alarmRule);
                if (index > -1) {
                    vm.allAlarmRules.splice(index, 1);
                    saveAlarmRules();
                }
            }
        );
    }

    function deleteAlarmRules($event) {
        if (vm.selectedAlarmRules && vm.selectedAlarmRules.length > 0) {
            var title = $translate.instant('alarm-rule.delete-alarm-rules-title', {count: vm.selectedAlarmRules.length}, 'messageformat');
            var content = $translate.instant('alarm-rule.delete-alarm-rules-text');
            var label = $translate.instant('alarm-rule.delete-alarm-rules');
            tkDialogs.confirm($event, title, content, label).then(
                () => {
                    for (var i=vm.selectedAlarmRules.length-1;i>=0;i--) {
                        var alarmRule = vm.selectedAlarmRules[i];
                        var index = vm.allAlarmRules.indexOf(alarmRule);
                        if (index > -1) {
                            vm.allAlarmRules.splice(index, 1);
                        }
                    }
                    saveAlarmRules();
                }
            );
        }
    }

    function saveAlarmRules() {
        if (vm.rulesScope == types.alarmRuleScope.gateway) {
            vm.alarmRulesPromise = gatewayGroupService.saveAlarmRules(vm.entityId.id, vm.allAlarmRules);
        }
        vm.alarmRulesPromise.then(
            () => {
                $rootScope.$broadcast('reloadEntityDetails');
            }
        );
    }

}

/*@ngInject*/
export function AlarmRuleController($rootScope, $scope, $mdDialog, $mdExpansionPanel, $mdUtil, $parse, $window, types, rulesScope, isReadOnly, isAdd, alarmRule, alarmRulesService) {

    var vm = this;

    vm.$onInit = function () {
        vm.$mdExpansionPanel = $mdExpansionPanel;
        vm.rulesScope = rulesScope;
        vm.isReadOnly = isReadOnly;
        vm.isAdd = isAdd;
        vm.alarmRule = alarmRule;

        vm.types = types;

        vm.alarmRuleTriggerTypes = rulesScope == types.alarmRuleScope.gateway ? types.gwAlarmRuleTriggerType : types.devAlarmRuleTriggerType;

        vm.addAlarmTrigger = addAlarmTrigger;
        vm.deleteAlarmTrigger = deleteAlarmTrigger;
        vm.alarmTriggerTypeChanged = alarmTriggerTypeChanged;

        vm.addNotification = addNotification;
        vm.deleteNotification = deleteNotification;
        vm.notificationTypeChanged = notificationTypeChanged;
        vm.notificationSmsToChanged = notificationSmsToChanged;

        vm.saveAlarmRule = saveAlarmRule;
        vm.cancel = cancel;

        vm.currentFocusElement = null;
        vm.setCurrentFocusElement = setCurrentFocusElement;
        vm.resetCurrentFocusElement = resetCurrentFocusElement;
        vm.selectChip = selectChip;

        vm.notificationRefs = {};
        vm.availableNotificationRefs = [];

        vm.loading = function () {
            return $rootScope.loading;
        };

        $mdUtil.nextTick(() => {
            updateValidity();
        });

        loadNotificationRefs();
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function loadNotificationRefs() {
        alarmRulesService.getNotificationRefs().then(
            (refs) => {
                vm.notificationRefs = refs;
                updateNotificationRefs();
            }
        )
    }

    function addAlarmTrigger() {
        var type = rulesScope == types.alarmRuleScope.gateway ? types.gwAlarmRuleTriggerType.GW_OFFLINE.value
                                                              : types.devAlarmRuleTriggerType.DEV_OFFLINE.value;
        vm.alarmRule.alarmTriggers.push({
            type: type
        });

        $scope.theForm.$setDirty();
        updateValidity();

        var panelId = 'alarmTriggerPanel' + (vm.alarmRule.alarmTriggers.length - 1);
            $mdExpansionPanel().waitFor(panelId)
                .then(
                    (panel) => {
                        panel.expand().then(
                            () => {
                                var scrollParent = angular.element('.tk-alarm-rule-dialog md-dialog-content');
                                scrollParent.animate({
                                 scrollTop: scrollParent.scrollTop() + (angular.element('#'+panelId).offset().top - scrollParent.offset().top)
                                }, 500);
                            });
                    }
                );
        
        updateNotificationRefs()
    }

    function deleteAlarmTrigger($event, alarmTrigger) {
        if ($event) {
            $event.stopPropagation();
        }
        var index = vm.alarmRule.alarmTriggers.indexOf(alarmTrigger);
        if (index > -1) {
            vm.alarmRule.alarmTriggers.splice(index, 1);
            $scope.theForm.$setDirty();
            updateValidity();
        }
        updateNotificationRefs()
    }

    function alarmTriggerTypeChanged(alarmTrigger, prevTypeValue) {
        var newType = vm.alarmRuleTriggerTypes[alarmTrigger.type];
        var prevType = vm.alarmRuleTriggerTypes[prevTypeValue];
        if (newType.isEvent && !prevType.isEvent) {
            alarmTrigger.severity = [];
            alarmTrigger.description = '*';
            alarmTrigger.state = [];
        } else if (!newType.isEvent && prevType.isEvent) {
            delete alarmTrigger.severity;
            delete alarmTrigger.description;
            delete alarmTrigger.state;
        }
        updateNotificationRefs()
    }

    function addNotification() {
        if (!vm.alarmRule.notifications) {
            vm.alarmRule.notifications = [];
        }
        vm.alarmRule.notifications.push({
            type: types.notificationType.EMAIL.value,
            configuration: {}
        });

        $scope.theForm.$setDirty();
        updateValidity();

        var panelId = 'notificationPanel' + (vm.alarmRule.notifications.length - 1);
        $mdExpansionPanel().waitFor(panelId)
            .then(
                (panel) => {
                    panel.expand().then(
                        () => {
                            var scrollParent = angular.element('.tk-alarm-rule-dialog md-dialog-content');
                            scrollParent.animate({
                                scrollTop: scrollParent.scrollTop() + (angular.element('#'+panelId).offset().top - scrollParent.offset().top)
                            }, 500);
                        });
                }
            );
    }

    function deleteNotification($event, notification) {
        if ($event) {
            $event.stopPropagation();
        }
        var index = vm.alarmRule.notifications.indexOf(notification);
        if (index > -1) {
            vm.alarmRule.notifications.splice(index, 1);
            $scope.theForm.$setDirty();
            updateValidity();
        }
    }

    function notificationTypeChanged(notification, prevTypeValue) {
        var newType = types.notificationType[notification.type];
        var prevType = types.notificationType[prevTypeValue];
        if (newType != prevType) {
            notification.configuration = {};
            if (newType === types.notificationType.SMS) {
                notification.configuration.smsTo = [];
                $mdUtil.nextTick(() => {
                    notificationSmsToChanged(notification);
                });
            } else if (newType === types.notificationType.MQTT){
                notification.configuration.port = 1883;
                notification.configuration.ssl = false;
                notification.configuration.retryInterval = 30;
            }
        }
    }

    function notificationSmsToChanged(notification) {
        var index = vm.alarmRule.notifications.indexOf(notification);
        $scope.theForm['smsTo'+index].$setValidity('required', notification.configuration.smsTo.length>0);
    }

    function updateValidity() {
        $scope.theForm.$setValidity('alarmTriggers', vm.alarmRule.alarmTriggers.length>0);
        $scope.theForm.$setValidity('notifications', vm.alarmRule.notifications.length>0);
    }

    function saveAlarmRule() {
        $scope.theForm.$setPristine();
        $mdDialog.hide(vm.alarmRule);
    }

    function updateNotificationRefs() {
        var triggerTypes = types.gwAlarmRuleTriggerType;
        var references = vm.notificationRefs['BASIC']
        var referencesByTriggerType = vm.alarmRule.alarmTriggers
            .map(el => vm.notificationRefs[triggerTypes[el.type].group]);
        if (referencesByTriggerType.length) {
            references = references.concat(referencesByTriggerType.reduce((a, b) => a.filter(c => b.includes(c))))
        }
        vm.availableNotificationRefs = references;
    }

    function setCurrentFocusElement(e) {
        vm.currentFocusElement = e.target;
    }

    function resetCurrentFocusElement() {
        vm.currentFocusElement = null;
    }

    function selectChip(notification, chip) {
        let activeElement = vm.currentFocusElement;

        if (activeElement) {
            let chipValue = `\$${chip}`;
            let startPosition = activeElement.selectionStart;
            let endPosition = activeElement.selectionEnd;
            let newPosition = startPosition + chipValue.length;

            let getter = $parse(activeElement.getAttribute('ng-model'));
            let setter = getter.assign;
            let oldValue = getter({ notification }) || "";
            let newValue = oldValue.substring(0, startPosition) + chipValue + oldValue.substring(endPosition);
            setter({ notification }, newValue);

            $window.requestAnimationFrame(() => {
                activeElement.focus();
                activeElement.setSelectionRange(newPosition, newPosition);
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/alarm-rule/alarm-rules.directive.js